export default __webpack_public_path__ + "static/media/skippedmeal_2@3x.9bbb1903.jpg";